// extracted by mini-css-extract-plugin
export default {"backToHome":"Share_backToHome__R3Uay","shareBox":"Share_shareBox__rh5iK","shareItem":"Share_shareItem__-Tlbh","shareImg":"Share_shareImg__xStFV"};